import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, friendlyError } from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function Login() {
  const navigate = useNavigate();
  const { loginToken } = useAuth();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ email: "piciva00@outlook.it", password: "", name: "", org_name: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      if (mode === "forgot") {
        const { data } = await api.post("/auth/forgot-password", { email: form.email });
        toast.success(data.message || "Se l'email è registrata, riceverai un link.");
        setMode("login");
        setBusy(false);
        return;
      }
      const url = mode === "login" ? "/auth/login" : "/auth/register";
      const { data } = await api.post(url, form);
      loginToken(data.token, data.user);
      navigate("/app/dashboard");
    } catch (err) {
      toast.error(friendlyError(err));
    } finally {
      setBusy(false);
    }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/app/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white">
      <div className="hidden lg:flex flex-col justify-between bg-[#0F172A] text-white p-12">
        <div className="font-head font-bold text-xl">RegIntel <span className="text-blue-400">CDMO</span></div>
        <div>
          <h2 className="font-head text-3xl font-bold leading-tight">Dalla novità regolatoria all'azione.</h2>
          <p className="mt-4 text-slate-400 max-w-md">
            Regulatory Intelligence, Change Impact e Document Intelligence per CDMO farmaceutiche sterili.
          </p>
        </div>
        <div className="text-xs text-slate-500 font-mono">FDA · EMA · PMDA · NMPA · ICH · PIC/S · WHO</div>
      </div>

      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <div className="ri-overline mb-2">{mode === "login" ? "Accesso" : "Registrazione"}</div>
          <h1 className="font-head text-2xl font-bold mb-6">
            {mode === "login" ? "Accedi alla piattaforma" : "Crea la tua organizzazione"}
          </h1>

          <button onClick={googleLogin} data-testid="google-login-btn"
            className="w-full flex items-center justify-center gap-2 border border-slate-300 rounded-lg py-2.5 text-sm font-medium hover:bg-slate-50 transition-colors mb-4">
            <img src="https://www.google.com/favicon.ico" alt="" className="w-4 h-4" /> Continua con Google
          </button>

          <div className="flex items-center gap-3 my-4 text-xs text-slate-400">
            <div className="flex-1 h-px bg-slate-200" /> oppure <div className="flex-1 h-px bg-slate-200" />
          </div>

          <form onSubmit={submit} className="space-y-3">
            {mode === "register" && (
              <>
                <input required placeholder="Nome completo" data-testid="register-name-input"
                  value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
                  className="w-full px-3 py-2.5 rounded-lg border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/40" />
                <input placeholder="Nome organizzazione" data-testid="register-org-input"
                  value={form.org_name} onChange={(e) => setForm({ ...form, org_name: e.target.value })}
                  className="w-full px-3 py-2.5 rounded-lg border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/40" />
              </>
            )}
            <input required type="email" placeholder="Email" data-testid="login-email-input"
              value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full px-3 py-2.5 rounded-lg border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/40" />
            {mode !== "forgot" && (
              <input required type="password" placeholder="Password" data-testid="login-password-input"
                value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
                className="w-full px-3 py-2.5 rounded-lg border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/40" />
            )}
            {mode === "login" && (
              <button type="button" onClick={() => setMode("forgot")} data-testid="forgot-link"
                className="text-xs text-blue-600 hover:underline">Password dimenticata?</button>
            )}
            <button type="submit" disabled={busy} data-testid="login-submit-btn"
              className="w-full py-2.5 rounded-lg bg-blue-700 text-white font-medium hover:bg-blue-800 transition-colors disabled:opacity-60">
              {busy ? "Attendere..." : mode === "login" ? "Accedi" : mode === "register" ? "Registrati" : "Invia link di reimpostazione"}
            </button>
          </form>

          <button onClick={() => setMode(mode === "login" ? "register" : "login")}
            className="mt-4 text-sm text-slate-500 hover:text-slate-900" data-testid="toggle-mode-btn">
            {mode === "register" ? "Hai già un account? Accedi" : mode === "forgot" ? "Torna all'accesso" : "Non hai un account? Registrati"}
          </button>
        </div>
      </div>
    </div>
  );
}
